import React from "react";
import logo from '../../src/img/logo.jpg';
import logoKrakow from '../../src/img/sponsors/logo-krakow3.jpg';
import logomarr from '../../src/img/organizers/logo-marr-main.png';
import { Link } from "react-router-dom";

export const Main = props => {
  return (
    <React.Fragment>
      <div className="main-page">
        <div className="main-congress-logo">
          <Link to="/o-zjezdzie">
            <img src={logo} alt="25 Zjazd Fizyków Polskich" />
          </Link>
        </div>
        <div className="main-partner-logo">
          <a href="http://www.business.krakow.pl">
              <div>
                <img src={logoKrakow} alt="Miasto Kraków" />
              </div>
            <div>Kraków miastem gospodarzem Zjazdu</div>
          </a>
        </div>
          <div className="main-partner-logo-marr">
              <a href="https://www.marr.pl/">
                  <div>
                      <img src={logomarr} alt="Małopolska Agnecja Rozwoju Regionalnego SA" />
                  </div>
                  <div>Małopolska Agnecja Rozwoju Regionalnego SA</div>
              </a>
          </div>
      </div>
    </React.Fragment>
  );
};
